import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=413c9be7&"
import script from "./caseDetail.vue?vue&type=script&lang=js&"
export * from "./caseDetail.vue?vue&type=script&lang=js&"
import style0 from "./caseDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports